import ObjectID from 'bson-objectid';

/**
 * Generates a new temporary id.
 * @returns {string} Temp id.
 */
export const generateTempId = (): string => `new-${generateBSONId()}`;

export const generateBSONId = (): string => new ObjectID().toHexString();
